import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	accordionSummaryClasses,
	Button,
	Stack,
} from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";
import React from "react";

type Props = {
	children: React.ReactNode;
	accordionSummary: React.ReactNode;
	expanded: boolean;
	onToggle: () => void;
	onDelete?: () => void;
};

const AccordionWizard = ({ accordionSummary, expanded, onToggle, onDelete, children }: Props) => {
	return (
		<Accordion
			expanded={expanded}
			onChange={() => onToggle()}
		>
			<AccordionSummary
				sx={{
					my: 0,
					px: 2,
					[`& .${accordionSummaryClasses.expanded}`]: {
						my: (theme) => `${theme.spacing(1.5)} !important`,
					},
				}}
				expandIcon={
					<Button
						variant="soft"
						sx={{
							width: 34,
							minWidth: "unset",
						}}
					>
						<Iconify
							color="action.active"
							width={18}
							icon="eva:arrow-ios-downward-fill"
						/>
					</Button>
				}
			>
				<Stack
					width="100%"
					direction="row"
					justifyContent="space-between"
					alignItems="center"
				>
					{accordionSummary}
					{onDelete && (
						<Stack direction="row" mr={1} spacing={1}>
							<Button
								variant="soft"
								sx={{
									width: 36,
									minWidth: "unset",
								}}
								onClick={(event) => {
									event.stopPropagation();

									onDelete();
								}}
							>
								<Iconify
									color="action.active"
									width={18}
									icon="solar:trash-bin-trash-bold"
								/>
							</Button>
						</Stack>
					)}
				</Stack>
			</AccordionSummary>
			<AccordionDetails sx={{ pt: 0 }}>{children}</AccordionDetails>
		</Accordion>
	);
};

export default AccordionWizard;
